module.exports = __webpack_public_path__ + "img/10.1.d4ef5413.png";